import { render, staticRenderFns } from "./TiemposPromedioGestion.vue?vue&type=template&id=13a75ae4&"
import script from "./TiemposPromedioGestion.vue?vue&type=script&lang=js&"
export * from "./TiemposPromedioGestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports